export default "__VITE_ASSET__CvYKSgfh__"